import React from "react";

import { SearchOutlined } from "@ant-design/icons";
import { Input } from "antd";
import "./search_input.less";
import { SizeType } from "antd/es/config-provider/SizeContext";
import _ from "lodash";

interface SearchInputProps {
  className?: string;
  disabled?: boolean;
  defaultValue?: string;
  size?: SizeType;
  onChange?: (value: string) => void;
  title?: string;
}

export const SearchInput: React.FC<SearchInputProps> = ({
  disabled,
  defaultValue,
  size = "middle",
  onChange,
  title,
}) => {
  function handleInputChange(e: React.ChangeEvent<HTMLInputElement>) {
    onChange && onChange(e.target.value);
  }

  const testId = title
    ? "filter-group-input-" + _.kebabCase(title)
    : "filter-group-input";

  return (
    <Input
      prefix={<SearchOutlined />}
      placeholder="Search"
      size={size}
      defaultValue={defaultValue}
      onChange={handleInputChange}
      disabled={disabled}
      data-testid={testId}
      className="search-input-filter"
    />
  );
};

export default SearchInput;
